import { DocumentsDataTableDocument } from 'generated/resources/datatable.graphql'
import {
  BulkUpdateVisibilityDocument,
  BulkUpdateVisibilityMutation,
  BulkUpdateVisibilityMutationVariables,
  DocumentsDocument,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

const useBulkUpdateVisibilityDocument = ({
  fromDataTable = false,
}: {
  fromDataTable?: boolean
}) => {
  const [bulkUpdateVisibilityMutation, { loading }] = useMutation(BulkUpdateVisibilityDocument, {
    extractorFn: (data: BulkUpdateVisibilityMutation) =>
      data.documentsMutations.bulkUpdateVisibilityDocumentsDocument,
  })

  return {
    loading,
    bulkUpdateVisibility(variables: BulkUpdateVisibilityMutationVariables) {
      return bulkUpdateVisibilityMutation({
        variables,
        awaitRefetchQueries: true,
        ...(fromDataTable
          ? {
              refetchQueries: [DocumentsDataTableDocument],
            }
          : {
              refetchQueries: [DocumentsDocument],
            }),
      })
    },
  }
}

export default useBulkUpdateVisibilityDocument
